module.exports = __webpack_public_path__ + "images/insights-ai-summary-65e67fcb.svg";